/* eslint-disable no-unused-expressions */
import React from 'react';

import './index.scss';
/** This component renders a confirmation modal; Gives users a choice to confirm or cancel choice to unsubmit category
 * @param modalId
 * @param unsubmitAction
 */

const UnsubmitConfirmation = ({modalId, unsubmitAction, cancelAction}) => {
   
  return (
    <div className='cb-modal' id={`${modalId}`} aria-hidden='true' data-cb-apricot='modal'>
      <div className='cb-modal-overlay' tabIndex='-1'>
        <div
          className='cb-modal-container'
          role='dialog'
          aria-modal='true'
          aria-labelledby={`${modalId}_Title`}
          aria-describedby={`dialogueDsc_${modalId}`}>
          <div className='cb-modal-header'>
            <div
              id={`${modalId}_Title`}
              className='display-flex justify-content-start align-items-center headerStyle'
              style={{width: '100%'}}>
              <span style={{marginRight: '5px'}} className='cb-icon cb-icon-circular cb-megaphone'></span>
              <span style={{width: '100%', display: 'flex', flexWrap: 'wrap'}}>Are you sure you want to unsubmit this category?</span>
            </div>
            {/* <!-- close button --> */}
            <button
              type='button'
              onClick={cancelAction}
              className='cb-btn cb-btn-square cb-btn-greyscale cb-btn-close'
              aria-describedby={`${modalId}_Title`}
              data-cb-modal-close>
              <span className='cb-icon cb-x-mark' aria-hidden='true' />
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div className='cb-modal-footer'>
            <div className='cb-btn-row footerbottomRow'>
              <button type='button' className='cb-btn cb-btn-naked' onClick={cancelAction} data-cb-modal-close aria-label='Continue editing' data-testid='confirmucanceltbutton'>
                Cancel
              </button>
              <button
                type='button'
                className='cb-btn cb-btn-primary'
                onClick={unsubmitAction}
                data-cb-modal-close
                data-testid='confirmunsubmitbutton'
                aria-label='Continue without saving'>
                Unsubmit Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnsubmitConfirmation;
